import $ from 'jquery';
import Timer from 'tick-tock';
import '@accessible360/accessible-slick';
import { sliderConfigs } from 'js/utils/settings';
import { mediaPlayerThumbs } from 'js/utils/settings';

export default class MediaGallery {
  constructor(element) {
    this.element = element;
    this.listen();
    this.index = null;
    this.timer = new Timer();
    this.$itemsCarousel = this.buildMainCarousel();
    this.$thumbsCarousel = this.buildThumbsCarousel();
  }

  handleBeforeChange(event, slick, currentSlide, nextSlide) {
    const $item = slick.$slides.eq(currentSlide).find('.media-gallery__item');
    const type = $item.attr('data-type');

    if (type === 'video') {
      const video = $item.find('video')[0];
      video.pause();
      video.currentTime = 0;
    }

    if (type === 'remote-video') {
      const iframe = $item.find('iframe')[0];
      if (iframe) {
        const src = iframe.getAttribute('src');
        iframe.removeAttribute('src');
        iframe.setAttribute('src', src);
      }
    }
  }

  handleClick(event) {
    const thumb = event.target.closest('.media-gallery__thumb');
    if (thumb) {
      const index = thumb.getAttribute('data-index');

      // Navigate main carousel to current slide index.
      this.$itemsCarousel.slick('slickGoTo', index);

      // Ensure the current slide isn't incorrect according to the index.
      this.thumbsContainer
        .querySelectorAll('.slick-current')
        .forEach((item) => {
          if (this.previousIndex !== index) {
            item.classList.remove('slick-current');
          }
        });

      // Correctly identify the current slide.
      thumb.closest('.slick-slide').classList.add('slick-current');
      this.previousIndex = index;
    }
  }

  buildMainCarousel() {
    return $(this.mainContainer).slick(sliderConfigs.mediaPlayer);
  }

  buildThumbsCarousel() {
    var items = $(this.thumbsContainer).find('.media-gallery__thumb').length;
    var thumbnailCarousel = $(this.thumbsContainer).slick(
      mediaPlayerThumbs(items),
    );

    $(this.thumbsContainer).addClass('thumb-container-' + items);

    thumbnailCarousel.on('breakpoint', function (e) {});
    return thumbnailCarousel;
  }

  listen() {
    $(this.mainContainer).on('beforeChange', this.handleBeforeChange);
    $(this.thumbsContainer).on('click', this.handleClick.bind(this));
  }

  get mainContainer() {
    return this.element.querySelector('.media-gallery__items');
  }

  get thumbsContainer() {
    return this.element.querySelector('.media-gallery__thumbs');
  }
}
